/**
 * Reality Check View
 */

define(function(require) {
    'use strict';

    var BaseView = require('common/base.view');
    var Form = require('class/form.class');
    var RealityCheckModel = require('portlets/responsible-gaming/reality-check/reality-check.model');

    return BaseView.extend({

        events: {
            'submit .fn-form-reality-check': 'handleRealityCheckSubmit'
        },

        initialize: function(options) {
            this.options = options;

            this.model = new RealityCheckModel();
            this.model.fetch();
        },

        subscribe: function() {
            this.listenTo(this.model, 'change', this.renderRealityCheck);
        },

        renderRealityCheck: function() {
            this.$el.html(this.tmpl('reality-check', this.model.toJSON()));

            if(this.model.get('realityCheckEnabled')) {
                this.form = new Form(this.$('.fn-form-reality-check'));
            }

            return this;
        },

        handleRealityCheckSubmit: function(e) {
            e.preventDefault();

            var timePeriod = Number(this.form.data('timePeriod'));

            this.form.showLoading();

            this.model.setRealityCheck(timePeriod)
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successUpdateRealityCheck.bind(this))
                .fail(this.errorUpdateRealityCheck.bind(this));
        },

        successUpdateRealityCheck: function() {
            this.showInfo({
                content: this.translate('playtech.mobile.ngresponsiblegaming.realityCheck.success')
            });
        },

        errorUpdateRealityCheck: function(response) {
            this.showError(response);
            this.renderRealityCheck();
        }
    });
});
